import { render } from "./page404.vue?vue&type=template&id=3d62ba2a&scoped=true"
import script from "./page404.vue?vue&type=script&lang=js"
export * from "./page404.vue?vue&type=script&lang=js"

import "./page404.vue?vue&type=style&index=0&id=3d62ba2a&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d62ba2a"]])

export default __exports__